import React, { useRef, useEffect } from "react";
import { DetailImageWrapper } from "./component/styled";

const DetailImage = ({ isDetailImage, toggleImageView }) => {
  const wrapperRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const img = imgRef.current;

    if (img && img.complete) {
      scrollToRight();
    } else if (img) {
      img.onload = () => {
        scrollToRight();
      };
    }
  }, [isDetailImage]);

  const scrollToRight = () => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollLeft = wrapperRef.current.scrollWidth;
    }
  };

  return (
    <DetailImageWrapper ref={wrapperRef} onClick={() => toggleImageView(null)}>
      <div className="rotated-wrapper">
        <img ref={imgRef} src={isDetailImage} alt="detail" />
      </div>
    </DetailImageWrapper>
  );
};

export default DetailImage;
